import {KilnShutdownsActions} from './KilnShutdownsActions'
import {KilnShutdownsFilters} from './KilnShutdownsFilters'
import {KilnShutdownsLabel} from './KilnShutdownsLabel'

import {ChartLegend} from '@refra/modules/common/components'

export const KilnShutdownsCardHeader: React.FC = () => {
  return (
    <div className={'flex flex-col gap-4'}>
      <div
        className="flex flex-col md:flex-row gap-4 md:gap-0 justify-between items-center"
        data-cy="kiln_shutdowns_card_header"
      >
        <KilnShutdownsLabel />
        <div className="flex justify-between items-center gap-8">
          <KilnShutdownsFilters />
          <KilnShutdownsActions />
        </div>
      </div>
      <div className="flex justify-end" data-cy="kiln_shutdowns_card_legend">
        <ChartLegend
          displayItems={['drive', 'tires', 'mortar', 'drillingCritical', 'drillingInfo']}
          translationKey={'refraPlanning.kilnShutdown'}
        />
      </div>
    </div>
  )
}
